<template>
  <div class="tree-slider">
    <!-- Header with arrow up and filter -->
    <div
      class="tool-bar d-flex align-start"
      :style="{
        width: xs ? '100vw' : '100%',
        height: '43px',
        position: 'sticky !important',
      }"
    >
      <div ref="treeHeader" class="tree-header d-flex ma-0 pa-0 full-width background lighten-2">
        <div class="filter-container ma-0 pa-0">
          <div class="d-flex flex-row">
            <navigate-up
              :style="{ width: '100%' }"
              showFilter
              :path="[]"
              :isFilterActive="isFilterActive"
              :isFilterVisible="isFilterVisible"
              :root-text-key="rootTextKey"
              @toggleFilter="onToggleFilter"
            >
            </navigate-up>
          </div>
        </div>
      </div>
    </div>

    <v-expand-transition>
      <div v-if="isFilterVisible" :style="`border-bottom:1px solid #${darkMode ? '101010' : 'd0d0d0'} !important`">
        <div class="d-flex flex-row full-width">
          <v-text-field ref="filterInput" v-model="filter" class="px-3 pt-2 ma-0 mb-3" :placeholder="$t('formFilterHint')" hide-details></v-text-field>
        </div>
        <div v-if="hasGroupFilter && usedGroups.length > 0" class="d-flex flex-row full-width px-3 ma-0 my-1">
          <groups-selection :groups="usedGroups"></groups-selection>
        </div>
      </div>
    </v-expand-transition>

    <transition :name="transition">
      <div v-if="showContent" :style="`transition:all 0.5s ease-in-out`">
        <div>
          <slot name="content"> </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixins/common';
import NavigateUp from './NavigateUp.vue';
import GroupsSelection from '../../modules/forms/GroupsSelection.vue';

export default {
  name: 'FormTreeSlider',
  mixins: [common],
  emits: ['onFilterChange'],
  components: {
    NavigateUp,
    GroupsSelection,
  },
  props: {
    rootTextKey: String, // the text key to be used when the navigateUp component is displayed within the root of a tree
    usedGroupIds: Object,
    groups: { type: Array, required: false },
  },
  data() {
    return {
      showContent: true,
      transition: 'slide-right',
      isFilterVisible: false,
      filter: '',
      windowHeight: 0,
      selectedLabels: [],
    };
  },
  computed: {
    groupsSortedBySort() {
      return this.groups ? this.groups.slice().sort((a, b) => a.sort - b.sort) : [];
    },
    selectedGroups: {
      get() {
        return this.$store.state.forms.selectedGroups;
      },
      set(value) {
        this.$store.commit('forms/setSelectedGroups', { value });
      },
    },
    hasGroupFilter() {
      if (this.childrenType === 'forms') {
        return false;
      }
      return this.groups.length > 0;
    },
    isFilterActive() {
      return this.filter.length > 0 || this.selectedGroups.length > 0;
    },
    usedGroups() {
      const groups = [...this.groups].filter((tag) => this.usedGroupIds[tag.id]);
      return groups.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
  },
  methods: {
    onToggleFilter() {
      this.filter = '';
      this.selectedGroups = [];
      this.isFilterVisible = !this.isFilterVisible;
      if (this.isFilterVisible) {
        window.setTimeout(() => {
          if (this.$refs.filterInput) {
            this.$refs.filterInput.focus();
          }
        }, 100);
      }
    },
  },
  watch: {
    filter(newValue) {
      this.$emit('onFilterChange', newValue);
    },
  },
};
</script>

<style scoped>
.index {
  position: relative;
  left: calc(100% - 20px);
  top: 6px;
  width: 22px;
  height: 0px;
  font-size: 8px;
}
.filter-container {
  overflow: hidden;
  width: calc(100%);
}
.filter {
  transition: transform 400ms;
  background: white;
  height: 36px;
}
.text-field:focus {
  outline: none;
}
/* NO SELECT + HIGHLIGHT COLOR ==> avoids copy/paste functions which is inappropriate on smart phones*/
* {
  user-select: none;
}
*::selection {
  background: none;
}
*::-moz-selection {
  background: none;
}
.tool-bar {
  font-size: 0.8rem;
  z-index: 2000;
  position: relative !important;
  left: 0;
  top: 0;
  transition: height 750ms;
  overflow: hidden;
  box-shadow: rgb(204, 204, 204) 0px 1px 0px;
}
</style>
